import { useHistory } from "react-router-dom";
import "./TutorHistory.scss";
import { toastifyMessage } from "../../../../../../custom_utilities/toastify_config";

const TutorHistory = ({ element, index, convertDate, renderQuestion }) => {
  const history = useHistory();
  const durationInMinutes = Math.round(element.callTime / 60000);

  const handleWatchClick = (e) => {
    e.stopPropagation(); // Prevent parent click

    if (!element?.video?.url || !element?.notes?.thumbnail) {
      toastifyMessage({
        status: 202,
        message: "video is not available at the moment.",
      });
      return;
    }

    history.push({
      pathname: "/tutor",
      state: { videoData: element }, // Pass element as videoData
    });
  };

  return (
    <div key={index} className="tutor-history-card">
      <div className="tutor-history-header">
        <span className="connected-date">
          Connected on: {convertDate(element.date)}
        </span>
        <span className="duration">Duration: {durationInMinutes} min</span>
      </div>
      <div className="tutor-history-content">
        <div className="tutor-left-content">
          <img
            src={element.video.thumbnail}
            alt="Thumbnail"
            className="thumbnail"
          />
          <div className="tutor-history-details">
            <h3 className="topic">{element.topics.join(", ")}</h3>
            <div className="question">
              {renderQuestion(element.questionText)}
            </div>
            <div className="instructor-info">
              <img
                src={element.instructor.profileImage}
                alt={element.instructor.name}
                className="instructor-image"
              />
              <span className="instructor-name">{element.instructor.name}</span>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <button className="watch-video-btn" onClick={handleWatchClick}>
          WATCH VIDEO
        </button>
      </div>
    </div>
  );
};

export default TutorHistory;
